(function(){
'use strict';

function injectStyles(){
  if(document.getElementById('pmy-mobile-footer-language-polish-css')) return;
  var s=document.createElement('style');
  s.id='pmy-mobile-footer-language-polish-css';
  s.textContent=`
@media (max-width:991px){
  .mobile-fab-checkout{
    --pmy-fab-lift:20px;
    bottom:calc(var(--pmy-fab-lift) + env(safe-area-inset-bottom, 0px))!important;
    background:rgba(0,102,0,.78)!important;
    -webkit-backdrop-filter:blur(14px) saturate(145%)!important;
    backdrop-filter:blur(14px) saturate(145%)!important;
    border:1px solid rgba(255,255,255,.42)!important;
    box-shadow:0 9px 28px rgba(0,0,0,.24), inset 0 1px 0 rgba(255,255,255,.18)!important;
    transition:bottom .24s ease, background .2s ease, box-shadow .2s ease, opacity .2s ease!important;
  }
  .mobile-fab-checkout:hover,
  .mobile-fab-checkout:focus-visible{
    background:rgba(0,102,0,.88)!important;
    box-shadow:0 11px 32px rgba(0,0,0,.28), inset 0 1px 0 rgba(255,255,255,.22)!important;
  }
}

@media (max-width:800px){
  .pmy-lang-overlay{
    padding:14px 12px calc(14px + env(safe-area-inset-bottom, 0px))!important;
    align-items:center!important;
    justify-content:center!important;
  }
  .pmy-lang-modal{
    width:min(100%,520px)!important;
    max-height:calc(100dvh - 28px - env(safe-area-inset-bottom, 0px))!important;
    border-radius:22px!important;
    box-shadow:0 22px 64px rgba(0,0,0,.30)!important;
  }
  .pmy-lang-head{
    padding:16px 18px 0!important;
    flex:0 0 auto!important;
  }
  .pmy-lang-close{
    width:42px!important;
    height:42px!important;
    font-size:26px!important;
  }
  .pmy-lang-tabs{
    margin-top:8px!important;
  }
  .pmy-lang-title{
    font-size:17px!important;
    padding-bottom:11px!important;
  }
  .pmy-lang-body{
    padding:18px 18px 24px!important;
    overscroll-behavior:contain;
  }
  .pmy-auto{
    width:100%!important;
    padding:15px!important;
    border-radius:14px!important;
    gap:14px!important;
    align-items:center!important;
  }
  .pmy-auto strong{
    font-size:16px!important;
    margin-bottom:4px!important;
  }
  .pmy-auto span{
    font-size:13.5px!important;
    line-height:1.45!important;
  }
  .pmy-auto-toggle{
    width:52px!important;
    height:30px!important;
    flex-basis:52px!important;
  }
  .pmy-auto-toggle:after{
    width:24px!important;
    height:24px!important;
  }
  .pmy-auto-toggle[aria-checked="true"]:after{
    transform:translateX(22px)!important;
  }
  .pmy-lang-section{
    margin-top:28px!important;
  }
  .pmy-lang-section h3{
    font-size:20px!important;
    line-height:1.22!important;
    margin:0 0 12px!important;
  }
  .pmy-lang-grid{
    grid-template-columns:1fr!important;
    gap:7px!important;
  }
  .pmy-lang-choice{
    min-height:60px!important;
    padding:10px 13px!important;
    border-radius:12px!important;
  }
  .pmy-lang-choice strong{
    font-size:15px!important;
  }
  .pmy-lang-choice span{
    font-size:13.5px!important;
  }
}

@media (min-width:480px) and (max-width:800px){
  .pmy-lang-grid{
    grid-template-columns:repeat(2,minmax(0,1fr))!important;
    gap:8px!important;
  }
}
`;
  document.head.appendChild(s);
}

function resetLanguageModalScroll(){
  var body=document.querySelector('#pmy-language-region-modal .pmy-lang-body');
  if(body) body.scrollTop=0;
}

function bindLanguageModal(){
  document.addEventListener('click',function(e){
    if(e.target.closest('.pmy-lang-globe') || e.target.closest('.pmy-footer-lang')){
      requestAnimationFrame(resetLanguageModalScroll);
    }
  },true);
}

function setupFabCollision(){
  var fab=document.querySelector('.mobile-fab-checkout');
  var footerBottom=document.querySelector('.main-footer .footer-bottom');
  if(!fab || !footerBottom) return;
  var ticking=false;

  function update(){
    ticking=false;
    if(window.innerWidth>991){
      fab.style.removeProperty('--pmy-fab-lift');
      return;
    }
    var r=footerBottom.getBoundingClientRect();
    var base=20;
    var lift=base;
    if(r.top < window.innerHeight && r.bottom > 0){
      lift=Math.max(base, Math.round(window.innerHeight-r.top+14));
    }
    fab.style.setProperty('--pmy-fab-lift',lift+'px');
  }

  function schedule(){
    if(ticking) return;
    ticking=true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('scroll',schedule,true);
  if('ResizeObserver' in window){
    new ResizeObserver(schedule).observe(footerBottom);
  }
  update();
}

function init(){
  injectStyles();
  bindLanguageModal();
  setupFabCollision();
}

if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
else init();
})();